<div class="side-menu-button cursor-pointer" (click)="toggleSideMenu()" [ngClass]="{ isSideMenuOpened: isOpen }">
    <fa-icon [icon]="faBars" size="lg"></fa-icon>
</div>
<div
    class="side-menu-container container-fluid"
    [ngClass]="{
        isOpening: isOpen,
        isClosing: !isOpen && hasBeenOpened,
    }"
    tabindex="0"
>
    <div class="sticky-menu position-sticky top-0 start-0"></div>

    <ng-container *ngIf="model.sections.length > 1; else emptySection">
        <ng-container *ngFor="let section of model.sections; first as isFirst; last as isLast">
            <!-- Section Header -->
            <div class="menu-section my-3 mx-0">
                <span>{{ section.title }}</span>
            </div>

            <!-- Menu Entries for Section -->
            <ng-container *ngFor="let entry of section.entries">
                <pace-core-menu-entry
                    *ngIf="entry.visible"
                    [model]="entry"
                    (click)="toggleSideMenu()"
                ></pace-core-menu-entry>
            </ng-container>

            <ng-container *ngIf="isFirst">
                <ng-content select="[paceWeeklyWorkTime]"></ng-content>
            </ng-container>

            <ng-container *ngIf="isLast">
                <pace-core-menu-entry [model]="barcodeClipboardEntry"></pace-core-menu-entry>
                <div *ngIf="furtherLinks.length > 0">
                    <div class="further-links-menu d-flex align-items-center">
                        <pace-core-menu-entry [model]="furtherLinksEntry"></pace-core-menu-entry>
                        <span class="chevron-icon-container cursor-pointer" (click)="toggleFurtherLinks()">
                            <fa-icon [icon]="isCollapsed ? faChevronDown : faChevronUp" aria-hidden="true"></fa-icon>
                        </span>
                    </div>
                    <ul *ngIf="showFurtherLinks" class="further-links ps-5">
                        <li *ngFor="let link of furtherLinks">
                            <div paceCoreLink (click)="toggleSideMenu()">
                                <a class="pace-link" href="{{ link.descText }}" target="_blank">{{ link.code }}</a>
                            </div>
                        </li>
                    </ul>
                </div>

                <ng-content select="[paceInformation]"></ng-content>
                <pace-core-menu-entry [model]="reportIssueEntry"></pace-core-menu-entry>
                <ng-content select="[corporateInformationMenuEntry]"></ng-content>
                <ng-container *ngIf="isPWADisplayMode">
                    <pace-core-menu-entry [model]="pushNotificationEntry"></pace-core-menu-entry>
                    <pace-core-menu-entry [model]="restartAppEntry"></pace-core-menu-entry>
                </ng-container>
            </ng-container>
        </ng-container>
    </ng-container>

    <!-- Looping over Empty Section -->
    <ng-template #emptySection>
        <ng-container *ngFor="let section of model.sections">
            <ng-container *ngFor="let entry of section.entries">
                <pace-core-menu-entry
                    *ngIf="entry.visible"
                    [model]="entry"
                    (click)="toggleSideMenu()"
                ></pace-core-menu-entry>
            </ng-container>
        </ng-container>
    </ng-template>
</div>
<div
    class="side-menu-backdrop"
    *ngIf="isOpen"
    (click)="toggleSideMenu()"
    [ngClass]="{
        isOpening: isOpen,
        isClosing: !isOpen && hasBeenOpened,
    }"
></div>
